// TODO: tymczasowa implementacja na localStorage (BE `/api/ui/sales-crm/filters` nie istnieje, zwraca 404).
// Docelowo wrocic do wywolan HTTP (GET/POST/PUT) aby presety synchronizowaly sie miedzy urzadzeniami tradera.

import { useQuery, useQueryClient, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IWiseTableAdvancedFilter } from 'components/wise/types';

export interface ISalesCrmFilterPreset {
  id: number;
  name: string;
  filters: IWiseTableAdvancedFilter[];
  column_visibility?: Record<string, boolean>;
  column_order?: string[];
}

export interface IGetSalesCrmFiltersResponse {
  items: ISalesCrmFilterPreset[];
}

const STORAGE_PREFIX = 'wiseTablePresets:';

export const salesCrmFiltersStorageKey = (componentSymbol: string): string =>
  `${STORAGE_PREFIX}${componentSymbol}`;

export const readSalesCrmFiltersFromStorage = (componentSymbol: string): ISalesCrmFilterPreset[] => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(salesCrmFiltersStorageKey(componentSymbol));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as ISalesCrmFilterPreset[]) : [];
  } catch {
    return [];
  }
};

export const writeSalesCrmFiltersToStorage = (
  componentSymbol: string,
  items: ISalesCrmFilterPreset[]
): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(salesCrmFiltersStorageKey(componentSymbol), JSON.stringify(items));
  } catch {
    // ignore quota / privacy mode
  }
};

const queryKey = (componentSymbol: string) => ['sales-crm', 'filters', componentSymbol];

export const useGetSalesCrmFilters = (
  componentSymbol: string,
  options?: UseQueryOptions<IGetSalesCrmFiltersResponse, IError> & { enabled?: boolean }
) =>
  useQuery<IGetSalesCrmFiltersResponse, IError>(
    queryKey(componentSymbol),
    () => Promise.resolve({ items: readSalesCrmFiltersFromStorage(componentSymbol) }),
    {
      ...options,
      enabled: (options?.enabled !== false && !!componentSymbol) ?? true
    }
  );

export const useInvalidateSalesCrmFilters = (componentSymbol: string) => {
  const qc = useQueryClient();
  return () => qc.invalidateQueries(queryKey(componentSymbol));
};

export { queryKey as getSalesCrmFiltersQueryKey };
